import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-27/task-03";

const task: Slide = {
  titleHtml:
    "What is the main perceived effect of an acoustic reflection arriving 200 milliseconds<br>after the direct sound?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
